import { Layout } from '@/components/Layout.tsx';
import { Icons } from '@/components/ui.tsx';
import { PRICING_FEATURES, PRICING_TIERS } from '@/data/content.ts';
import { href } from '@/lib/paths.ts';

export function Pricing() {
  return (
    <Layout currentPath="/pricing" navOnLight={true}>
      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="container pricing-hero__content">
          <h1>
            Simple pricing for schools
            <br />
            that want to lead
          </h1>
          <p className="pricing-hero__lede">
            We&apos;re currently onboarding early adopters at a special rate.
          </p>
        </div>
      </section>

      {/* Early Adopter Program Banner */}
      <section className="pricing-early-adopter">
        <div className="container pricing-early-adopter__content">
          <h2>Early Adopter Program &mdash; Limited Availability</h2>
          <p>
            We&apos;re partnering with a select group of schools and districts
            to shape the future of AI in education. Early adopters get preferred
            pricing, direct input on product development, and priority support.
          </p>
          <div className="pricing-early-adopter__badge">
            <span>EARLY ADOPTER WINDOW CLOSES FEBRUARY 1, 2027</span>
          </div>
          <div>
            <a
              href={href('/contact')}
              className="btn pricing-early-adopter__btn"
            >
              Apply for Early Access
            </a>
          </div>
        </div>
      </section>

      {/* Pricing Tiers Section */}
      <section className="pricing-tiers-section">
        <div className="container">
          <div className="pricing-grid">
            {PRICING_TIERS.map((tier) => (
              <div
                key={tier.title}
                className={`pricing-card fade-in ${
                  tier.popular ? 'pricing-card--popular' : ''
                }`.trim()}
              >
                {tier.popular && (
                  <div className="pricing-card__popular-badge">
                    <span>MOST POPULAR</span>
                  </div>
                )}
                <div className="pricing-card__header">
                  <h3>{tier.title}</h3>
                  <p>{tier.description}</p>
                </div>
                <div className="pricing-card__price">
                  <span>Contact for</span>
                  <strong>pricing</strong>
                </div>
                <a
                  href={href(tier.ctaHref)}
                  className={`btn ${
                    tier.popular ? 'btn--primary' : 'btn--dark'
                  } pricing-card__btn`}
                >
                  {tier.ctaLabel}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Feature Checklist Section */}
      <section className="pricing-features-section">
        <div className="container">
          <h2 className="fade-in">Everything you need to succeed</h2>
          <div className="pricing-features-grid">
            {PRICING_FEATURES.map((feature) => (
              <div key={feature} className="pricing-feature-item fade-in">
                <div className="pricing-feature-item__icon-box">
                  {Icons.check('pricing-feature-item__icon')}
                </div>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
